import { Link } from 'react-router-dom';
import {
  BarChart3,
  Box,
  Gift,
  ListChecks,
  MessageSquare,
  Headphones,
  Shield,
  ArrowRight,
  Users,
} from 'lucide-react';
import { useBreadcrumbs } from '@/client/hooks/use-breadcrumbs';

const SECTIONS = [
  {
    title: 'Visitor Insights',
    description: 'Visitors, sources, pages, locations and devices, from our own data and Plausible.',
    href: '/admin/analytics/visitors',
    icon: Users,
  },
  {
    title: 'Customer support',
    description: 'Ticket volume, response performance, and L1/L2/L3 capacity.',
    href: '/admin/support',
    icon: Headphones,
  },
  {
    title: 'Listings',
    description: 'Listing reports, performance, and marketplace activity.',
    href: '/admin/listings/reports',
    icon: ListChecks,
  },
  {
    title: 'Assets',
    description: 'Media usage, storage, and asset analytics.',
    href: '/admin/assets/usage',
    icon: Box,
  },
  {
    title: 'Escrow',
    description: 'Escrow transaction reports and financial analytics.',
    href: '/admin/escrow/reports',
    icon: Shield,
  },
  {
    title: 'Promotions',
    description: 'Campaign performance metrics and conversion.',
    href: '/admin/promotions/metrics',
    icon: Gift,
  },
  {
    title: 'Messaging',
    description: 'WhatsApp delivery, engagement, and conversation analytics.',
    href: '/admin/relationship/whatsapp/analytics',
    icon: MessageSquare,
  },
];

const AnalyticsOverviewPage = () => {
  useBreadcrumbs([{ label: 'Analytics' }, { label: 'Overview' }]);

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="mb-8">
        <div className="mb-1 flex items-center gap-3">
          <BarChart3 className="h-7 w-7 text-blue-700" />
          <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>
        </div>
        <p className="ml-10 text-sm text-gray-500">
          Jump into domain reports across the platform.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {SECTIONS.map((section) => (
          <Link
            key={section.href}
            to={section.href}
            className="group rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition hover:border-blue-200 hover:shadow-md"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-700">
                <section.icon className="h-5 w-5" />
              </div>
              <ArrowRight className="h-4 w-4 text-gray-300 transition group-hover:translate-x-0.5 group-hover:text-blue-600" />
            </div>
            <h2 className="mt-4 text-base font-semibold text-gray-900">{section.title}</h2>
            <p className="mt-1 text-sm text-gray-500">{section.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsOverviewPage;
